/* global Sys, Core, Services, Resources, Language, Utils */
Sys.ns("Core");

/**
 * The Play For Real Promo model.
 *
 * @class Core.PlayForRealPromoModel
 * @extends Core.Model
 */
Core.PlayForRealPromoModel = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.PlayForRealPromoModel.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    setupData: function() {
        var initResponse = Resources.readData("gameServerInitResponse") || {},
            rounds;

        if (initResponse.playforfun && Sys.isDefined(initResponse["playforrealpromo.rounds"])) {
            rounds = Sys.utils.toInt(initResponse["playforrealpromo.rounds"]);
            this.storeData("roundsLeft", rounds);
            this.storeData("rounds", rounds);
        }
    },

    /**
     * Get the dialog config.
     *
     * @param {Object} scope The scope to use for the buttons.
     * @returns {Object} Dialog config.
     */
    getDialog: function(scope) {
        var continueBtn = {
                text: Services.languageManager.getText(Language.Keys.btn_continue),
                scope: scope,
                action: function() {
                    scope.fireEvent("notify:dialogBoxClosed", { name: "playForRealPromo", button: "continue" });
                    scope.complete();
                },
                buttonId: "Continue"
            },
            loginBtn = {
                text: Services.languageManager.getText(Language.Keys.btn_login),
                scope: scope,
                action: function() {
                    scope.fireEvent("notify:dialogBoxClosed", { name: "playForRealPromo", button: "login" });
                    scope.complete();
                    Sys.utils.goToLobby(Utils.CONSTANTS.REASON_CODES.WANTS_TO_PLAY_FOR_REAL);
                },
                primary: true,
                buttonId: "PlayReal"
            };

        return {
            name: Utils.CONSTANTS.DIALOG_NAMES.PLAY_4_REAL,
            title: Services.languageManager.getText(Language.Keys.youPlayingForFun),
            buttons: Sys.utils.isHomeAvailable() ? [continueBtn, loginBtn] : [continueBtn]
        };
    },

    /**
     * Handles rounds by counting down and resetting when count has reach zero.
     *
     * @returns {void}
     */
    handleRounds: function() {
        var rounds = this.readData("roundsLeft"),
            newCount;

        if (rounds === 0) {
            newCount = this.readData("rounds");
        }
        else {
            newCount = --rounds;
        }

        this.storeData("roundsLeft", newCount);
    }
};

Core.PlayForRealPromoModel = Sys.extend(Core.Model, Core.PlayForRealPromoModel, "Core.PlayForRealPromoModel");
